module.exports = __webpack_public_path__ + "static/media/wth-screens.8f4fa99a.png";